import http from '@shared/http';
import { NEXUS_V1_URL } from '@shared/const';

import {
  CreateCheckoutSessionResponseDTO,
  GetAccountResponseDTO, GetBillingPortalResponseDTO, GetProductsResponseDTO,
  CreateCheckoutSessionRequestDTO
} from './types';

export const paymentsApi = {
  getBillingPortal: (accountId: string) =>
    http.get<GetBillingPortalResponseDTO>(
      `${NEXUS_V1_URL}/payments/customers/${accountId}/billing-portal`,
      { return_url: window.location.href }
    ),
  getAccount: (accountId: string) =>
    http.get<GetAccountResponseDTO>(`${NEXUS_V1_URL}/payments/customers/${accountId}`),
  getProducts: () =>
    http.get<GetProductsResponseDTO>(
      `${NEXUS_V1_URL}/payments/products`,
      { business_identifier: APPLICATION_BUSINESS_IDENTIFIER, apps: 'hub' }
    ),
  createCheckoutSession: (accountId: string, body: CreateCheckoutSessionRequestDTO) =>
    http.post<CreateCheckoutSessionResponseDTO>(`${NEXUS_V1_URL}/payments/customers/${accountId}/checkout`, {
      products: body.products,
      success_url: body.success_url,
      cancel_url: body.cancel_url,
    }),
};

export default paymentsApi;
